"use client";

import { Layers, Store, Plug, WifiOff } from "lucide-react";
import ServicePage from "@/components/ServicePage";
import MetadataUpdater from "@/components/MetadataUpdater";
import { serviceSummary } from "@/data/knowledge/services";

export default function MobileAppsPage() {
  return (
    <>
    <MetadataUpdater
      titleKey="meta.solutions.mobileApps.title"
      description={serviceSummary("mobile-apps")}
    />
    <ServicePage
      labelKey="service.mobile.label"
      titleKey="service.mobile.title"
      descriptionKey="service.mobile.description"
      benefits={[
        {
          icon: Layers,
          titleKey: "service.mobile.benefit1.title",
          descKey: "service.mobile.benefit1.desc",
        },
        {
          icon: Store,
          titleKey: "service.mobile.benefit2.title",
          descKey: "service.mobile.benefit2.desc",
        },
        {
          icon: Plug,
          titleKey: "service.mobile.benefit3.title",
          descKey: "service.mobile.benefit3.desc",
        },
        {
          icon: WifiOff,
          titleKey: "service.mobile.benefit4.title",
          descKey: "service.mobile.benefit4.desc",
        },
      ]}
      usecaseKeys={[
        "service.mobile.usecase1",
        "service.mobile.usecase2",
        "service.mobile.usecase3",
        "service.mobile.usecase4",
      ]}
      stack={[
        "Flutter",
        "Dart",
        "Firebase",
        "Supabase",
        "REST API",
        "Bloc",
        "iOS",
        "Android",
        "Play Store",
        "App Store",
        "Figma",
        "Penpot",
        "Fastlane",
        "Isar",
      ]}
    />
    </>
  );
}
